import { createFeatureSelector, createSelector } from "@ngrx/store";
import type { CalendarIntegrationState } from "./calendar-integration.models";

export const selectCalendarIntegrationState = createFeatureSelector<CalendarIntegrationState>('calendarIntegration');

export const selectCalendarIntegrations = createSelector(
  selectCalendarIntegrationState,
  (state) => state.integrations
);

export const selectCalendarIntegrationLoading = createSelector(
  selectCalendarIntegrationState,
  (state) => state.loading
);

export const selectCalendarIntegrationError = createSelector(
  selectCalendarIntegrationState,
  (state) => state.error
);

